import clsx from "clsx";
import { AnimatePresence, motion } from "framer-motion";
import { PropsWithChildren } from "react";

const animateVariants = {
  hide: {
    y: "100vh",
    opacity: 0,
    scale: 0.95,
  },
  show: {
    y: "0",
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.2,
      type: "spring",
      damping: 25,
      stiffness: 300,
    },
  },
  exit: {
    y: "100vh",
    opacity: 0,
    scale: 0.95,
    transition: {
      duration: 0.15,
    },
  },
};

interface BackdropProps extends PropsWithChildren {
  onClick: () => void;
}

export interface ModalProps {
  show?: boolean;
  onClose: () => void;
}

function Backdrop(props: BackdropProps) {
  return (
    <motion.div
      className="bg-black/60 fixed inset-0 flex items-center justify-center h-full p-4 z-[110]"
      onClick={props.onClick}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      {props.children}
    </motion.div>
  );
}

export function Modal(props: PropsWithChildren<ModalProps>) {
  return (
    <AnimatePresence>
      {props.show && (
        <Backdrop onClick={props.onClose}>
          <motion.div
            className={clsx(
              "bg-white rounded-2xl overflow-hidden shadow-xl w-full max-w-sm mx-auto",
              "p-6 sm:p-8 max-h-[90vh] overflow-y-auto"
            )}
            onClick={(e) => e.stopPropagation()}
            variants={animateVariants}
            initial="hide"
            animate="show"
            exit="exit"
          >
            {props.children}
          </motion.div>
        </Backdrop>
      )}
    </AnimatePresence>
  );
}
